import type { ToastType, ToastOptions, ToastPosition } from "./types";
import { addToast } from "./store";

export type { ToastType, ToastOptions, ToastPosition };
export { default as ToastContainer } from "./ToastContainer";

let counter = 0;

const DEFAULT_DURATION = 5000;
const DEFAULT_POSITION: ToastPosition = "bottom-right";

function show(type: ToastType, message: string, options?: ToastOptions): string {
  const id = `toast-${++counter}-${Date.now()}`;
  addToast({
    id,
    type,
    message,
    description: options?.description,
    duration: options?.duration ?? DEFAULT_DURATION,
    position: options?.position ?? DEFAULT_POSITION,
    createdAt: Date.now(),
  });
  return id;
}

export const toast = {
  success: (message: string, options?: ToastOptions) => show("success", message, options),
  warning: (message: string, options?: ToastOptions) => show("warning", message, options),
  error: (message: string, options?: ToastOptions) => show("error", message, options),
};
